/**
 * promotions_time.js
 * Toggles promotion visibility based on date range
 * from hidden #startpromotion / #endpromotion elements.
 */
(function() {
  'use strict';

  $(document).ready(function() {
    function parseDate(input) {
      var dateTimeParts = input.match(/(\d+)/g);
      if (dateTimeParts && dateTimeParts.length >= 5) {
        var year = dateTimeParts[2];
        var month = dateTimeParts[1] - 1;
        var day = dateTimeParts[0];
        var hours = dateTimeParts[3];
        var minutes = dateTimeParts[4];
        return new Date(year, month, day, hours, minutes).getTime();
      }
      return null;
    }

    var metaFechaStart = document.getElementById('startpromotion');
    var metaFechaEnd = document.getElementById('endpromotion');
    if (!metaFechaStart || !metaFechaEnd) return;

    var fechaActualLondres = new Date().toLocaleString('en-GB', { timeZone: 'Europe/London' });
    var fechaInicio = new Date(metaFechaStart.textContent).toLocaleString('en-GB', { timeZone: 'Europe/London' });
    var fechaFin = new Date(metaFechaEnd.textContent).toLocaleString('en-GB', { timeZone: 'Europe/London' });

    var cantidadElementos = $('.BannerHeroFlicker').length;

    if (parseDate(fechaActualLondres) >= parseDate(fechaInicio) && parseDate(fechaActualLondres) <= parseDate(fechaFin)) {
      $('.promotime').css('display', 'block');
      if (cantidadElementos === 2) {
        $('.BannerHeroFlicker').eq(0).css('display', 'none');
      }
    } else if (cantidadElementos === 2) {
      $('.BannerHeroFlicker').eq(1).css('display', 'none');
    }
  });

})();
